import Promise from 'promise-polyfill'

if (window && !window.Promise) {
  window.Promise = Promise
}
